import { Box, Table, TableBody, TableCell, TableRow, TableHeader } from 'grommet'

var partedReactions = []

function ReactionResults(props) {
    for(let i=0; i < props.nNodes; i++){
        partedReactions[i] = new Array(2)
        for(let j = 0; j<3; j++){
            partedReactions[i][j] = props.results[3*i+j]
        }
    }
  return (
      <Box justify='center' align='center' pad='xsmall'>
        <h2>Reações</h2>
        <Table>
            <TableHeader>
                <TableRow>
                  <TableCell scope="col" border="bottom">
                    Nó
                  </TableCell>
                  <TableCell scope="col" border="bottom">
                    X
                  </TableCell>
                  <TableCell scope="col" border="bottom">
                    Y
                  </TableCell>
                  <TableCell scope="col" border="bottom">
                    Mz
                  </TableCell>
                </TableRow>
              </TableHeader>
            <TableBody>
                {partedReactions.map((item, i) => {
                  return(
                    <TableRow>
                        <TableCell>
                        {i+1}
                      </TableCell>

                      <TableCell>
                        {item[0] < 0.0001 && item[0] > 0 ? 0 + " kN" : item[0].toFixed(2) + " kN"}
                      </TableCell>

                      <TableCell>
                        {item[1] < 0.0001 && item[1] > 0 ? 0 + " kN" : item[1].toFixed(2) + " kN"}
                      </TableCell>

                      <TableCell>
                        {item[2] < 0.0001 && item[2] > 0 ? 0 + " kN.m" : item[2].toFixed(2) + " kN.m"}
                      </TableCell>
                    </TableRow>
                  )})}
            </TableBody>
        </Table>
      </Box>
  )
}

export default ReactionResults